import {
  useRetrieveCurrentPlanzone,
  useZonesProjectsRetrieval,
  useZoneProjectsRetrieval,
} from "@planzone/view-models";
import { zone, zoneProjectsRetrievalFilter } from "@planzone/dto";
import { useWorkspaceContext } from "@scenes/workspaceContext";

const defaultFilter = {
  ...zoneProjectsRetrievalFilter,
  limit: 999,
  isSortedByJoinedProject: true,
  isOpen: true,
  isSortedAlphabetically: true,
};

function useProjects() {
  const { planzone } = useRetrieveCurrentPlanzone();
  const ctx = useWorkspaceContext();
  const isInZone = ctx.type === "zone";
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    projects,
    retrieveZonesProjects,
  } = useZonesProjectsRetrieval();
  const {
    isRequestPending: isZoneRequestPending,
    isRequestSuccess: isZoneRequestSuccess,
    isRequestFailure: isZoneRequestFailure,
    projects: zoneProjects,
    retrieveZoneProjects,
  } = useZoneProjectsRetrieval(
    isInZone ? ctx.zone : { ...zone, uuid: "" },
    defaultFilter,
  );

  return isInZone
    ? {
        isRequestPending: isZoneRequestPending,
        isRequestSuccess: isZoneRequestSuccess,
        isRequestFailure: isZoneRequestFailure,
        projects: zoneProjects,
        retrieveProjects: () =>
          retrieveZoneProjects({ zone: ctx.zone, filter: defaultFilter }),
      }
    : {
        isRequestPending,
        isRequestSuccess,
        isRequestFailure,
        projects,
        retrieveProjects: () => retrieveZonesProjects(planzone),
      };
}

export { useProjects };
